export const Constants = {
  baseBackApiUrl: 'https://portal-api.renewstrategies.com',
  // baseBackApiUrl: 'http://localhost:1337',
  maxBlogContentLength: 100,
  maxTopicCardContentLength: 100,
  maxResourceCardTitleLength: 20,
  maxResourceCardContentLength: 50,
};
